const enum Action {
    NEW_URL = 'new-url',
    LOAD_LINK = 'load-link',
}

export default Action;
